import Link from "next/link";

export interface NavbarItemProps {
	label: string;
	href: string;
}

export default function NavbarItem({ label, href }: NavbarItemProps) {
	return (
		<Link
			className="px-3.5 py-2 text-sm font-medium hover:text-primary-accent-hover transition-colors"
			href={href}
		>
			{label}
		</Link>
	);
}
